export default "__VITE_ASSET__DM8sjwP5__"